import { render, staticRenderFns } from "./ManageCategory.vue?vue&type=template&id=c1a7e946&scoped=true"
import script from "./ManageCategory.vue?vue&type=script&lang=js"
export * from "./ManageCategory.vue?vue&type=script&lang=js"
import style1 from "./ManageCategory.vue?vue&type=style&index=1&id=c1a7e946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a7e946",
  null
  
)

export default component.exports